import { IReduxOperations } from "src/store";
import { ISingleManageMetrics } from "src/shared/models/ManageMetricsModel";

export enum ClearTypes {
  FETCH = "FETCH",
  UPDATE = "UPDATE",
}

export type UpdateMetricsActionPayload = {
  data: Array<ISingleManageMetrics>;
  switchBackToHome: () => void;
};

export interface IManageMetricsRootState {
  fetchedManageMetrics: IReduxOperations;
  updatedManageMetrics: IReduxOperations;
}
